import { combineReducers } from 'redux';
import main from './states/MainState';
import ui from './states/UIState';
import trendUrl from './states/TrendUrlState';
import user from './states//UserState';
import ICombinedState from './interfaces/ICombinedState';

export default combineReducers<ICombinedState>({ main, ui, trendUrl, user });
